import React, { FC, useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { data, IResultDataItem, IIncomingDataItem } from './TradingBalancesTableLists'
import { TableSmall } from '../../../../../../components/Dashboard/TableSmall'
import { useRest } from '../../../../../../components/Context'
// import { GreenButton } from '../../../../../../components/Dashboard/Buttons/GreenButton'
// import { MemoFundAccountPopup } from '../FundAccountPopup'
// import { MemoRequestSettlementPopup } from '../RequestSettlementPopup'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    // padding: theme.spacing(0, 4, 4, 4),
    // background: 'rgb(49,52,58)',
  },
  buttonsWrap: {
    margin: theme.spacing(-2),
  },
  button: {
    paddingBottom: theme.spacing(4),
  },
}))

interface TradingBalancesSectionProps {
  title?: string
  // hideFundButton?: boolean
  // hideSettlementButton?: boolean
}

export const TradingBalances: FC<TradingBalancesSectionProps> = ({
  title /* hideFundButton, hideSettlementButton */,
}) => {
  const classes = useStyles()
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const { rxiosAuth } = useRest()
  const [loading, setLoading] = useState<boolean>(false)
  const [values, setValues] = useState<IResultDataItem[]>([])
  /*  const [isOpenFundModal, setOpenFundModal] = useState<boolean>(false)
  const [isOpenSettlementFundModal, setOpenSettlementModal] = useState<boolean>(false)

  const openModal = useCallback(
    (event) => {
      if (event.target.textContent === 'Fund Account') setOpenFundModal((prevState) => !prevState)
      if (event.target.textContent === 'Request Settlement') setOpenSettlementModal((prevState) => !prevState)
    },
    [setOpenFundModal, setOpenSettlementModal],
  )

  const closeModal = useCallback(() => {
    setOpenFundModal(false)
    setOpenSettlementModal(false)
  }, [setOpenFundModal, setOpenSettlementModal])
*/

  const transformData = useCallback((incomingData: IIncomingDataItem[]) => {
    if (incomingData) {
      const crypto: string[] = []
      const fiat: string[] = []
      const array = []

      if (incomingData) {
        incomingData.map((item: IIncomingDataItem) => {
          if (item.isCurrencyCrypto) {
            crypto.push(`${[item.asset]}: ${item.amount}`)
          } else {
            fiat.push(`${[item.asset]}: ${item.amount}`)
          }
          return []
        })
      }

      for (let i = 0; i < 3; i += 1) {
        array.push({ fiatCurrencies: fiat[i], cryptoCurrencies: crypto[i] })
      }

      setValues(array)
    }
  }, [])

  const loadData = useCallback(async () => {
    let cleanupFunction = false
    setLoading(true)

    rxiosAuth.get(data.request).subscribe(
      // eslint-disable-next-line
      (next: any) => {
        transformData(next)
        if (!cleanupFunction) setLoading(false)
      },
      (error) => {
        toast.error(error)
        setLoading(false)
      },
      () => {
        setLoading(false)
      },
    )
    cleanupFunction = true
    // eslint-disable-next-line
  }, [rxiosAuth])

  useEffect(() => {
    ;(async () => {
      await loadData()
    })()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Grid item xs={12} className={classes.formWrap}>
        <FormProvider {...formMethods}>
          <Grid item xs={12} className={classes.container}>
            {title ? <Typography variant={'h6'}>{title}</Typography> : ' '}
          </Grid>
          <Grid item xs={12} className={classes.sectionWrap}>
            <TableSmall
              columns={data.columns}
              data={values}
              // data={stateData}
              pb={16}
              loading={loading}
            />
          </Grid>
        </FormProvider>
      </Grid>

      {/* <MemoFundAccountPopup isOpen={isOpenFundModal} modalClose={closeModal} /> */}
      {/* <MemoRequestSettlementPopup isOpen={isOpenSettlementFundModal} modalClose={closeModal} /> */}
    </>
  )
}
